export { default as protocolList } from "./protocols/protocolList.json"
export { default as protocolCustomContent } from "./protocols/protocolCustomContent"
export type { default as ProtocolText } from "./types/ProtocolText"

export { default as spectraTokens } from "./tokens/spectraTokens.json"
export { default as erc4626Wrappers } from "./tokens/erc4626Wrappers.json"